module.exports = __webpack_public_path__ + "assets/bg-pc-e3a671c2.png";